(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("members-area-app-editor-script", [], factory);
	else if(typeof exports === 'object')
		exports["members-area-app-editor-script"] = factory();
	else
		root["members-area-app-editor-script"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 